import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useFurnitureTypeQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/inventorymanagement/furnituretypes', 'get');

    return { data, loading, error, refetch };
};
